<div class="wrap">
    <div class="grid-container">
        <div *ngIf="loading" class="spinner">
            <mat-progress-spinner color="accent" mode="indeterminate" [diameter]="40"></mat-progress-spinner>
        </div>
        <ejs-grid #grid
                  [dataSource]="gridData"
                  [allowPaging]="true"
                  [pageSettings]="pageSettings"
                  [allowFiltering]="true"
                  [filterSettings]="filterSettings"
                  [allowSorting]="true"
                  [allowResizing]="true"
                  [allowSelection]="false"
                  [enableHover]="false"
                  [rowHeight]="36"
                  height="100%"
                  class="sync-grid"
                  (rowDataBound)="rowDataBound($event)"
                  (dataStateChange)="onDataStateChange($event)"
                  (recordClick)="onRecordClick($event)">
            <e-columns>
                <e-column headerText="Select" width="70" freeze="Left" [allowFiltering]="false" [allowSorting]="false" [allowResizing]="false" textAlign="Center">
                    <ng-template #headerTemplate>
                        <div class="header-select-checkbox">
                            <mat-checkbox matTooltip="Select every matching request, on all pages" [checked]="allSelected" [indeterminate]="someSelected" (change)="toggleSelectAll($event.checked)"></mat-checkbox>
                        </div>
                    </ng-template>
                    <ng-template #template let-data>
                        <mat-checkbox [checked]="isSelected(data)" (click)="onCheckboxClick($event, data)"></mat-checkbox>
                    </ng-template>
                </e-column>
                <e-column field="id" headerText="Request Id" width="110" textAlign="Right" headerTextAlign="Left" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="dateRequested" headerText="Requested Date" width="180" type="date" clipMode="EllipsisWithTooltip" [format]="{ type: 'dateTime', format: 'dd/MM/yyyy HH:mm:ss' }" textAlign="Center"></e-column>
                <e-column field="matterNo" headerText="Matter No" width="110" textAlign="Right" headerTextAlign="Left" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="matter" headerText="Matter" width="150" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="type" headerText="Type" width="110" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="client" headerText="Client" width="140" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="currencyCode" headerText="Currency" width="100" [filter]="{ type: 'CheckBox' }" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="amount" headerText="Transfer Amount" width="130" textAlign="Right" headerTextAlign="Left" clipMode="EllipsisWithTooltip">
                    <ng-template #template let-data>
                        {{ data.amount | number:'1.2-2' }}
                    </ng-template>
                </e-column>
                @if(isCompletedTab){
                <e-column field="clientBankAccountName" headerText="Client Bank Account Name" [filter]="{ type: 'CheckBox' }" width="200" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="reason" headerText="Reason for Transfer" width="200" clipMode="EllipsisWithTooltip"></e-column>
                }
                <e-column field="partnerAuthorisingName" headerText="Partner Authorising" width="160" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="dateAuthorised" headerText="Authorised Date" width="180" type="date" clipMode="EllipsisWithTooltip" [format]="{ type: 'dateTime', format: 'dd/MM/yyyy HH:mm:ss' }" textAlign="Center">
                    <ng-template #template let-data>
                        {{ data.dateAuthorised ? (data.dateAuthorised | date:'dd/MM/yyyy HH:mm:ss') : 'N/A' }}
                    </ng-template>
                </e-column>
                <e-column field="dateTransaction" headerText="Transaction Date" width="180" type="date" clipMode="EllipsisWithTooltip" [format]="{ type: 'dateTime', format: 'dd/MM/yyyy HH:mm:ss' }" textAlign="Center">
                    <ng-template #template let-data>
                        {{ data.dateTransaction ? (data.dateTransaction | date:'dd/MM/yyyy HH:mm:ss') : 'N/A' }}
                    </ng-template>
                </e-column>
                <e-column field="recentStatus" headerText="Status" width="180" clipMode="EllipsisWithTooltip" [filter]="{ type: 'CheckBox' }"></e-column>
                @if(isCompletedTab){
                <e-column field="returnReason" headerText="Rejected Reason" width="200" type="string" clipMode="EllipsisWithTooltip"></e-column>
                }
                <e-column headerText="Actions" width="100" freeze="Right" [allowFiltering]="false" [allowSorting]="false" textAlign="Center">
                    <ng-template #template let-data>
                        <div class="action-buttons">
                            <button (click)="onViewTransfer(data)" mat-icon-button color="accent" matTooltip="View transfer">
                                <mat-icon>visibility</mat-icon>
                            </button>
                            <button (click)="downloadRequestPdf(data.id, RequestType.TransferFund)" mat-icon-button color="accent" matTooltip="Download transfer fund report">
                                <mat-icon>picture_as_pdf</mat-icon>
                            </button>
                        </div>
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
        <div *ngIf="noData && !loading && !loadError" class="no-data-message">No transfer fund requests found.</div>
        <xp-grid-load-error *ngIf="loadError && !loading" message="The requests could not be loaded." (retry)="retryLoad()"></xp-grid-load-error>
    </div>
</div>
